import React from 'react';
import { useState } from 'react';
import { safeParseJSON } from '../utils/jsonValidator';
import { resolveConfig } from '../helpers/configResolver';

export function useResolveBodyData(body_data) {
    const [bodyData, setbodyData] = useState(safeParseJSON(body_data));

    const resolveInfo = (data, key = null) => {
        const obj = resolveConfig(bodyData, data, {}, key);
        setbodyData(obj);
    }

    return { bodyData, resolveInfo };
}
